import { Component, ChangeDetectionStrategy, OnDestroy} from '@angular/core';
import { Router } from '@angular/router';
import { Subject} from 'rxjs';
@Component({
    selector: 'div.page__container',
    templateUrl: '../templates/layout.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class LayoutComponent implements OnDestroy {
    private d$: Subject<boolean> = new Subject()
    isBk!:boolean
    constructor(
        private r:Router,
    ) {
      this.isBk = /\/bookmakers/.test(this.r.url)
    }
    ngOnDestroy(): void {
        this.d$.next(true)
        this.d$.complete()
    }
}
